import React, { Component, Fragment } from 'react';
import { Item, Button } from 'semantic-ui-react';
import moment from 'moment';
import { graphql, compose } from 'react-apollo';
import { withFormik } from 'formik';

import { AttachFlight } from '../../mutations/AttachFlight';
import apiBaseUrl from '../../utils/apiBaseUrl';
import FormView from './FormView';
import { formikConfig } from './formikConfig';

class AddFlight extends Component {
  state = {
    fetchInfoButton: { content: 'Fetch Flight Info', color: 'blue' },
    isAddFlightVisible: false
  };

  componentDidUpdate() {
    const { status } = this.props;
    if (status && status.refresh) {
      this.props.setStatus({});
      this.props.resetForm();
      this.setState({
        fetchInfoButton: { content: 'Fetch Flight Info', color: 'blue' },
        isAddFlightVisible: false,
        loading: false
      });
    }
  }

  fetchFlightInfo = () => {
    const { airline, flightNo, departureDate } = this.props.values;
    this.setState({ loading: true });
    const url = `${String(
      apiBaseUrl
    )}/traveler/api/1/flight_schedules/search/${airline}/${flightNo}/${moment(
      departureDate,
      'YYYY-MM-DD'
    ).format('YYYY-MM-DD')}.json`;
    const xhr = new XMLHttpRequest();

    xhr.onloadend = () => {
      if (xhr.readyState === 4) {
        const { setValues, values } = this.props;

        if (xhr.status === 200) {
          const data = JSON.parse(xhr.response);
          if (!data) return;
          setValues({
            ...values,
            airportOrigin: data.originCode,
            airportDestination: data.destinationCode,
            arrivalDate: moment(departureDate).add(
              data.arrivalDayDifference,
              'day'
            ),
            departureTime: data.departureTime,
            arrivalTime: data.arrivalTime
          });
          this.setState({
            fetchInfoButton: { content: 'Flight found', color: 'green' }
          });
        } else {
          setValues({
            ...values,
            airportOrigin: '',
            airportDestination: '',
            arrivalDate: undefined,
            departureTime: '',
            arrivalTime: ''
          });
          this.setState({
            fetchInfoButton: { content: 'Flight not found', color: 'red' }
          });
        }
      }
      this.setState({ loading: false });
    };
    xhr.open('GET', url);
    xhr.send();
  };
  handleAddFlightOpen = () => this.setState({ isAddFlightVisible: true });
  handleChange = (e, { name, value }) => this.props.setFieldValue(name, value);
  handleTimeChange = (value, name) => this.props.setFieldValue(name, value);

  handleFromDate = departureDate =>
    this.props.setFieldValue('departureDate', departureDate);
  handleToDate = arrivalDate =>
    this.props.setFieldValue('arrivalDate', arrivalDate);
  handleBlur = name => this.props.setFieldTouched(name, true);

  render = () => {
    const { isAddFlightVisible, fetchInfoButton } = this.state;
    const { loading, isSubmitting } = this.props;
    return (
      <Item.Group>
        {!isAddFlightVisible && (
          <Fragment>
            <Button
              primary
              size='mini'
              floated='right'
              icon={'plus'}
              name='Flight'
              labelPosition='left'
              className='c-TicketDetails__add-btn'
              content={'Add Flight'}
              onClick={this.handleAddFlightOpen}
              type='submit'
            />
            <br />
          </Fragment>
        )}
        {isAddFlightVisible && (
          <FormView
            onAddFlightOpen={this.handleAddFlightOpen}
            onChange={this.handleChange}
            onTimeChange={this.handleTimeChange}
            onFromDate={this.handleFromDate}
            onToDate={this.handleToDate}
            onBlur={this.handleBlur}
            fetchFlightInfo={this.fetchFlightInfo}
            fetchInfoButton={fetchInfoButton}
            loading={loading || isSubmitting || this.state.loading}
            {...this.props}
          />
        )}
      </Item.Group>
    );
  };
}

export default compose(
  graphql(AttachFlight, { name: 'AttachFlight' }),
  withFormik(formikConfig)
)(AddFlight);



// WEBPACK FOOTER //
// ./src/component/AddFlight/index.js